(function () {
  'use strict';

  var STORAGE_KEY = 'catchy_wishlist_v2';

  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; }
    catch (e) { return []; }
  }

  function saveWishlist(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  }

  function getIds() {
    return getWishlist().map(function(p) { return String(p.id); });
  }

  function toggle(btn) {
    var id = String(btn.dataset.wishlist);
    var list = getWishlist();
    var idx = list.findIndex(function(p) { return String(p.id) === id; });
    var added;
    if (idx === -1) {
      list.push({
        id: id,
        title: btn.dataset.wishlistTitle || '',
        url: btn.dataset.wishlistUrl || '',
        image: btn.dataset.wishlistImage || '',
        price: btn.dataset.wishlistPrice || ''
      });
      added = true;
    } else {
      list.splice(idx, 1);
      added = false;
    }
    saveWishlist(list);
    updateAllButtons();
    updateWishlistBadge();
    showWishlistToast(added);
    return added;
  }

  function isWished(id) {
    return getIds().indexOf(String(id)) !== -1;
  }

  function updateAllButtons() {
    document.querySelectorAll('[data-wishlist]').forEach(function (btn) {
      var id = btn.dataset.wishlist;
      var wished = isWished(id);
      btn.classList.toggle('is-wished', wished);
      var label = btn.querySelector('.wishlist-btn__label');
      if (label) label.textContent = wished ? 'Remove from Wishlist' : 'Add to Wishlist';
      var svg = btn.querySelector('svg');
      if (svg) svg.setAttribute('fill', wished ? 'currentColor' : 'none');
      btn.setAttribute('aria-label', wished ? 'Remove from wishlist' : 'Add to wishlist');
    });
  }

  function showWishlistToast(added) {
    var existing = document.getElementById('wishlist-toast');
    if (existing) existing.remove();
    var toast = document.createElement('div');
    toast.id = 'wishlist-toast';
    toast.textContent = added ? '\u2665 Added to Wishlist' : 'Removed from Wishlist';
    toast.style.cssText = 'position:fixed;bottom:7rem;left:50%;transform:translateX(-50%);background:var(--c-black);color:var(--c-white);padding:0.75rem 1.5rem;font-size:0.8125rem;letter-spacing:0.08em;z-index:500;opacity:0;transition:opacity 0.3s;pointer-events:none;';
    document.body.appendChild(toast);
    requestAnimationFrame(function () {
      toast.style.opacity = '1';
      setTimeout(function () {
        toast.style.opacity = '0';
        setTimeout(function () { toast.remove(); }, 350);
      }, 2000);
    });
  }

  // Delegated click
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    toggle(btn);
  });

  // Wishlist page render (if element exists)
  var wishlistPage = document.getElementById('wishlist-page-grid');
  if (wishlistPage) {
    var list = getWishlist().filter(function(p) { return p.title && p.title.length > 0; });
    saveWishlist(list);
    if (!list.length) {
      wishlistPage.innerHTML = '<p style="text-align:center;color:var(--c-dark-gray);padding:3rem;">Your wishlist is empty.</p>';
    } else {
      var html = '';
      list.forEach(function(prod) {
        html += '<div class="wl-item">';
        if (prod.image) html += '<a href="' + prod.url + '"><img class="wl-item__img" src="' + prod.image + '" alt="' + prod.title + '"></a>';
        html += '<div class="wl-item__info">';
        html += '<a href="' + prod.url + '" class="wl-item__title">' + prod.title + '</a>';
        if (prod.price) html += '<div class="wl-item__price">EGP ' + Math.round(parseInt(prod.price) / 100) + '</div>';
        html += '<a href="' + prod.url + '" class="wl-item__atc">VIEW PRODUCT</a>';
        html += '</div>';
        html += '<button class="wl-item__remove" onclick="removeFromWishlistById(' + prod.id + ', this)" title="Remove">';
        html += '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
        html += '</button>';
        html += '</div>';
      });
      wishlistPage.innerHTML = html;
    }
  }

  updateAllButtons();

  // Header wishlist badge
  function updateMobileWishlistBadge(count) {
    var badge = document.getElementById('mobile-wishlist-count');
    if (!badge) return;
    if (count > 0) { badge.textContent = count; badge.style.display = 'flex'; }
    else { badge.style.display = 'none'; }
  }

  function updateWishlistBadge() {
    var count = getWishlist().length;
    updateMobileWishlistBadge(count);
    var btn = document.getElementById('header-wishlist-btn');
    if (!btn) return;
    var badge = btn.querySelector('.wishlist-header-badge');
    if (count > 0) {
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'cart-count wishlist-header-badge';
        btn.appendChild(badge);
      }
      badge.textContent = count;
      badge.style.display = 'flex';
    } else {
      if (badge) badge.style.display = 'none';
    }
  }

  updateWishlistBadge();

  window.removeFromWishlistById = function(id, btn) {
    var list = getWishlist().filter(function(p) { return String(p.id) !== String(id); });
    saveWishlist(list);
    updateWishlistBadge();
    if (btn) btn.closest('.wl-item').remove();
    var page = document.getElementById('wishlist-page-grid');
    if (page && !page.querySelector('.wl-item')) {
      page.innerHTML = '<p style="text-align:center;color:var(--c-dark-gray);padding:3rem;">Your wishlist is empty.</p>';
    }
  };

  window.CATCHY = window.CATCHY || {};
  window.CATCHY.wishlist = { toggle: toggle, isWished: isWished, getList: getWishlist };
})();
